import { connect } from 'react-redux';
import Header from '@configuratorware/configurator-frontendgui/App/Shared/Components/Header';
import { createPropsFromState } from '@configuratorware/configurator-frontendgui/App/Shared/Containers/Header';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { getConf } from '@configuratorware/configurator-frontendgui/App/configuration';

const tools = [
  {
    key: 'save',
    identifier: 'cloud_download',
    title: 'headerMenu.save',
    function: () => Services.interaction.saveConfiguration(),
    enabled: getConf('availableTools.save'),
  },
  {
    key: 'load',
    identifier: 'cloud_upload',
    title: 'headerMenu.load',
    function: () => Services.interaction.showLoadConfigurationDialog(),
    enabled: getConf('availableTools.load'),
  },
  {
    key: 'mail',
    identifier: 'share',
    title: 'headerMenu.sendEmail',
    function: () => Services.interaction.shareConfiguration(),
    enabled: getConf('availableTools.share'),
  },
  {
    key: 'picture_as_pdf',
    identifier: 'picture_as_pdf',
    title: 'headerMenu.saveAsPdf',
    function: () => Services.interaction.printConfigurationAndOpenPdf(),
    enabled: getConf('availableTools.print'),
  },
];

const mapStateToProps = ({ configurator }: { configurator: any }) => ({
  ...createPropsFromState(configurator),
  tools: tools.filter((t) => t.enabled),
});

const mapDispatchToProps = () => ({
  switchSelectedAmount: (oldIdentifier: string, newIdentifier: string) =>
    Services.configurator.switchSelectedAmount(oldIdentifier, newIdentifier),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header as any);
